import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import { mq, Text, theme } from "@pallet-hq/hegel"
import { FlexColumn } from "components/atoms"
import Image from "components/Image"
import { WelcomeShortCandidatePreview_candidate } from "__generated__/WelcomeShortCandidatePreview_candidate"

const ShortCandidatePreviewFragment = gql`
    fragment WelcomeShortCandidatePreview_candidate on PublicCandidateType {
        id
        userCurrentTitle
        anonymousCompanyName
        anonymousProfileImage
    }
`

type ShortCandidatePreviewProps = {
    candidate: WelcomeShortCandidatePreview_candidate
}

const ShortCandidatePreview = ({ candidate }: ShortCandidatePreviewProps) => (
    <Wrapper>
        <ImageWrapper>
            <StyledImage
                src={candidate.anonymousProfileImage}
                width={64}
                height={64}
                borderRadius="100%"
                alt={candidate.userCurrentTitle}
                colorSlug=""
            />
        </ImageWrapper>
        <FlexColumn>
            <StyledTitle variant="uiLarge500" mb="xsmall">
                {candidate.userCurrentTitle}
            </StyledTitle>
            <StyledSubtitle variant="paragraphMedium">
                {candidate.anonymousCompanyName}
            </StyledSubtitle>
        </FlexColumn>
    </Wrapper>
)

ShortCandidatePreview.fragment = ShortCandidatePreviewFragment
export default ShortCandidatePreview

const Wrapper = styled.div`
    display: inline-flex;
    align-items: center;
    border: 1px solid ${theme.colors.gray200};
    border-radius: 16px;
    min-width: 20vw;
    box-sizing: border-box;

    ${mq({ padding: [theme.space.xsmall, theme.space.medium] })};
`

const ImageWrapper = styled.div`
    flex-shrink: 0;
    margin-right: ${theme.space.small};

    ${mq({
        width: [34, 64],
        height: [34, 64],
    })};
`

const StyledImage = styled(Image)`
    width: 100%;
    height: 100%;
`

const StyledTitle = styled(Text)`
    ${mq({
        fontSize: [8, 16],
        lineHeight: ["11px", "20px"],
    })}
`

const StyledSubtitle = styled(Text)`
    ${mq({
        fontSize: [8, 14],
        lineHeight: ["11px", "20px"],
    })}
`
